import React, { useEffect } from 'react';
import AnimatedBackground from '../components/AnimatedBackground';
import { GYM_INFO, TESTIMONIALS } from '../mock';
import { Star, Quote } from 'lucide-react';

const Reviews = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <AnimatedBackground />

      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-4 uppercase">
            Success <span className="text-[#39FF14]">Stories</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">
            Real transformations from real people. Join 500+ satisfied members who achieved their fitness goals at Iron Crust Gym.
          </p>

          {/* Overall Rating */}
          <div className="inline-flex items-center gap-3 bg-gradient-to-br from-[#1a1a1a] to-black px-8 py-4 rounded-full border border-[#39FF14]/20">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-[#39FF14] fill-[#39FF14]" />
              ))}
            </div>
            <span className="text-white font-bold text-2xl">4.9</span>
            <span className="text-gray-400">/ 5</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {TESTIMONIALS.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gradient-to-br from-[#1a1a1a] to-black p-8 rounded-3xl border border-[#39FF14]/20 hover:border-[#39FF14] transition-all duration-300 hover:scale-105"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <div className="w-12 h-12 bg-[#39FF14]/20 rounded-lg flex items-center justify-center">
                  <Quote className="w-6 h-6 text-[#39FF14]" />
                </div>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#39FF14] fill-[#39FF14]" />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between pt-6 border-t border-[#39FF14]/20">
                <div>
                  <p className="text-white font-bold text-lg">{testimonial.name}</p>
                  <p className="text-[#39FF14] text-sm font-medium">{testimonial.result}</p>
                </div>
                <div className="w-12 h-12 bg-[#39FF14]/20 rounded-full flex items-center justify-center">
                  <span className="text-[#39FF14] font-bold text-xl">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="text-center bg-gradient-to-br from-[#1a1a1a] to-black p-8 rounded-3xl border border-[#39FF14]/20">
            <div className="text-5xl font-black text-[#39FF14] mb-2">500+</div>
            <p className="text-gray-400 font-medium">Successful Transformations</p>
          </div>
          <div className="text-center bg-gradient-to-br from-[#1a1a1a] to-black p-8 rounded-3xl border border-[#39FF14]/20">
            <div className="text-5xl font-black text-[#39FF14] mb-2">4.9</div>
            <p className="text-gray-400 font-medium">Average Rating</p>
          </div>
          <div className="text-center bg-gradient-to-br from-[#1a1a1a] to-black p-8 rounded-3xl border border-[#39FF14]/20">
            <div className="text-5xl font-black text-[#39FF14] mb-2">98%</div>
            <p className="text-gray-400 font-medium">Member Satisfaction</p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-24 text-center bg-gradient-to-br from-[#1a1a1a] to-black p-12 md:p-16 rounded-3xl border border-[#39FF14]/20">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6 uppercase">
            Ready to Write Your <span className="text-[#39FF14]">Success Story</span>?
          </h2>
          <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
            Join Iron Crust Gym today and become our next transformation success story
          </p>
          <a
            href={`${GYM_INFO.whatsappLink}?text=Hi, I want to start my transformation at Iron Crust Gym!`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#39FF14] text-black font-bold text-lg uppercase rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-[#39FF14]/50 transition-all duration-300"
          >
            Start Your Journey
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
